import React from 'react';
import styles from './Nexsets.module.scss';
import { JumboBanner } from 'new/elements/JumboBanner';
import { AddCircle, ArrowForwardRounded } from '@mui/icons-material';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_DISCOVER } from 'new/constants/pathnames';
import { Typography } from '@mui/material';
import { useMyNexsets } from 'new/hooks/adapters/useMyNexsets';
import { Stack } from 'new/elements/Stack';
import { Button } from 'new/elements/Button';
import { ListApiItems } from 'new/components/discover/NexsetsAPI/components/ListAPIItems';

interface NexsetsProps {}

const bannerDesc =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla morbi nisl pretium fermentum morbi sem ut turpis. Porttitor tincidunt vivamus in id leo nisi, vitae mi. ';

export const NexsetsAPI: ScreenComponent<NexsetsProps> = (props: NexsetsProps) => {
  const nexsets = useMyNexsets();
  return (
    <div>
      <div className={styles.topContainer}>
        <JumboBanner
          title="Your Nexsets Encyclopedia"
          description={bannerDesc}
          cta={{ title: 'Learn More', startIcon: <AddCircle /> }}
        />
      </div>
      <Stack direction="row">
        <Stack flex={1}>
          <Stack direction="row">
            <Typography variant="subtitle1" className={styles.searchResultsTitle}>
              Recent Nexsets data API
            </Typography>
            <Button endIcon={<ArrowForwardRounded />}>View all</Button>
          </Stack>
          <ListApiItems items={nexsets} />
        </Stack>
        <Stack flex={1}>
          <Stack flex={1} direction="row">
            <Typography variant="subtitle1" className={styles.searchResultsTitle}>
              Top Nexsets data API
            </Typography>
            <Button endIcon={<ArrowForwardRounded />}>View all</Button>
          </Stack>
          <ListApiItems items={nexsets} />
        </Stack>
      </Stack>
    </div>
  );
};

NexsetsAPI.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_DISCOVER}/nexsets-api`,
  screenName: 'NexsetsAPI',
  domain: 'discover',
};
